import {
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { useGlobalModal } from "@/hooks/useGlobalModal";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import type { Matter, MatterSubItemType } from "@/lib/types";
import { FileText, NotebookPen, Plus } from "lucide-react";

interface MatterSubItemNotesContextMenuProps {
  matter: Matter;
  onOpenNotes: () => void;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemNotesContextMenu = ({
  matter,
  onOpenNotes,
  subItem,
}: MatterSubItemNotesContextMenuProps) => {
  const { hasActionPermission } = useUser();
  const { openNoteModal } = useGlobalModal();
  const canCreateNotes = hasActionPermission(
    ACTION_PERMISSION_KEYS.matter,
    ACTION_PERMISSION_VALUES.update,
  );

  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>
        <NotebookPen />
        Notes
      </ContextMenuSubTrigger>
      <ContextMenuSubContent>
        <ContextMenuItem onSelect={onOpenNotes}>
          <FileText />
          Open notes
        </ContextMenuItem>
        {canCreateNotes ? (
          <ContextMenuItem
            onSelect={() => {
              openNoteModal({
                matterId: matter.id,
                editing: false,
                initialTab: "details",
                subItem,
              });
            }}
          >
            <Plus />
            Create note
          </ContextMenuItem>
        ) : null}
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
};
